import { createSlice } from "@reduxjs/toolkit";
import { AppointmentTypeDTO } from "../../models/AppointmentType.model";
import { loginUser } from "../thunks/authThunks";
import { refreshCompanyData } from "../thunks/companyDataThunks";

export interface AppointmentTypeState {
  appointmentTypes: AppointmentTypeDTO[];
  loading: boolean;
  error: string | null;
  initialized: boolean;
}

const initialState: AppointmentTypeState = {
  appointmentTypes: JSON.parse(
    sessionStorage.getItem("appointmentTypes") || "[]"
  ),
  loading: false,
  error: null,
  initialized: !!sessionStorage.getItem("appointmentTypes"),
};

const appointmentTypeSlice = createSlice({
  name: "appointmentType",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearAppointmentTypes: (state) => {
      state.appointmentTypes = [];
      state.initialized = false;
      state.error = null;
      sessionStorage.removeItem("appointmentTypes");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.fulfilled, (state, action) => {
        const { appointmentTypes } = action.payload;
        if (appointmentTypes && appointmentTypes.length > 0) {
          state.appointmentTypes = appointmentTypes;
          state.initialized = true;
          state.error = null;
          sessionStorage.setItem(
            "appointmentTypes",
            JSON.stringify(appointmentTypes)
          );
        }
      })
      .addCase(refreshCompanyData.fulfilled, (state, action) => {
        const { appointmentTypes } = action.payload;
        if (appointmentTypes && appointmentTypes.length > 0) {
          state.appointmentTypes = appointmentTypes;
          state.initialized = true;
          state.error = null;
          sessionStorage.setItem(
            "appointmentTypes",
            JSON.stringify(appointmentTypes)
          );
        }
      });
  },
});

export const { clearError, clearAppointmentTypes } =
  appointmentTypeSlice.actions;
export default appointmentTypeSlice.reducer;
